import { loadView } from '@/router/routerHelpers';

export default [
  {
    path: '/forms/sign/:submissionId',
    name: 'formSign',
    props: true,
    component: loadView('forms/FormSign'),
  },
];
